var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "identity" },
    [
      _vm.userName
        ? _c(
            "div",
            {
              staticClass: "user",
              on: {
                click: function($event) {
                  _vm.loginOutModalVisible = true
                }
              }
            },
            [_vm._v("\n    " + _vm._s(_vm.userName) + "\n  ")]
          )
        : _c("div", { staticClass: "dfinity" }, [
            _c("img", {
              attrs: { src: "/img/dfinity.png" },
              on: { click: _vm.doIdentity }
            })
          ]),
      _vm._v(" "),
      _vm.identity && !_vm.userName
        ? _c(
            "a-modal",
            {
              attrs: {
                visible: _vm.userNameModalVisible,
                title: _vm.$t("title"),
                cancelText: _vm.$t("cancelText"),
                okText: _vm.$t("okText"),
                centered: "",
                closable: "false",
                okButtonProps: { props: { disabled: _vm.inputUserNameOkClose } }
              },
              on: { ok: _vm.userNameOkClick, cancel: _vm.userNameCancelClick }
            },
            [
              _c("a-input", {
                model: {
                  value: _vm.inputUserName,
                  callback: function($$v) {
                    _vm.inputUserName = $$v
                  },
                  expression: "inputUserName"
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.identity && _vm.userName
        ? _c(
            "a-modal",
            {
              attrs: {
                visible: _vm.loginOutModalVisible,
                title: _vm.$t("loginOutTitle"),
                cancelText: _vm.$t("cancelText"),
                okText: _vm.$t("okText"),
                centered: "",
                closable: "false"
              },
              on: { ok: _vm.loginOutOkClick, cancel: _vm.loginOutCancelClick }
            },
            [_vm._v("\n    " + _vm._s(_vm.$t("logoutContent")) + "\n  ")]
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }